export default __webpack_public_path__ + "static/media/JenukalGuddaHill.11a76e3f.jpg";